export const oandaFaviconLinks = {
    default: 'https://www.oanda.com/assets/images/favicon.ico',
    '192x192': 'https://www.oanda.com/assets/images/favicon-180x180.png',
};

export const appleOandaFaviconLinks = {
    default: 'https://www.oanda.com/assets/images/favicon.ico',
    '192x192': 'https://www.oanda.com/assets/images/favicon-180x180.png',
};
